// ─── LPC Talent — Translations ────────────────────────────────────────────────
// Source of truth: src/text and languages/LPC_Talent_Translations.csv
// Update the CSV for readability, then sync changes here.

export const T = {

  // ── SPANISH (default — primary audience: Colombian candidates) ────────────
  es: {
    // TOPBAR
    topbar_wa: 'Para más información: WhatsApp',

    // NAV
    nav_care:    'Global Care',
    nav_intern:  'Pasantías',
    nav_about:   'Sobre LPC Talent',
    nav_how:     'Cómo funciona',
    nav_faq:     'Preguntas frecuentes',
    nav_contact: 'Contacto',
    nav_cta:     'Inscribirme →',

    // HERO
    hero_badge:      'Colombia → Países Bajos · LPC Talent',
    hero_h1a:        'Tu camino hacia los Países Bajos empieza aquí:',
    hero_h1b:        'creando puentes de talento a través de los continentes.',
    hero_sub:        'LPC Talent acompaña a enfermeros/as profesionales colombianos hacia una carrera estable en los Países Bajos, y ofrece a estudiantes automotrices una pasantía valiosa en empresas líderes. Con honestidad, cercanía y acompañamiento completo.',
    hero_btn_care:   'Trabajar en salud',
    hero_btn_intern: 'Hacer una pasantía',
    trust1: 'Talento colombiano en los Países Bajos',  trust1_sub: 'En proceso de colocación activa',
    trust2: 'Acompañamiento completo',       trust2_sub: 'Te guiamos en cada paso del proceso',
    trust3: 'Honestos sobre los requisitos', trust3_sub: 'Sin falsas promesas, solo información clara',

    // REQUIREMENTS BAR
    req1_label: 'Requisito Global Care',  req1_val: 'Neerlandés B1',
    req2_label: 'Requisito Pasantías',    req2_val: 'Inglés A2/B1',
    req3_label: 'Apoyo de sostenimiento', req3_val: 'aprox. €1.250/mes',
    req4_label: 'Acompañamiento',         req4_val: 'De principio a fin',

    // FEATURE GRID (wave banner 2×3)
    feat1_title: 'Oportunidades profesionales',
    feat1_text:  'Te conectamos con posiciones reales en empresas neerlandesas — contrato legal, compensación justa y un proceso pensado para que funcione de verdad.',
    feat1_back:  'Conectamos talento colombiano con empleadores neerlandeses que ofrecen posiciones reales con responsabilidad y crecimiento. Incluye apoyo en CV, entrevistas y negociación de condiciones.',
    feat2_title: 'Acompañamiento cultural',
    feat2_text:  'Te acompañamos para integrarte en la cultura neerlandesa: idioma, costumbres y vida cotidiana, para que llegues con confianza.',
    feat2_back:  'Preparación completa para el entorno neerlandés: idioma, cultura laboral y vida cotidiana. No llegas solo, llegas preparado. Incluye talleres y mentoría antes de tu llegada.',
    feat3_title: 'Proceso guiado',
    feat3_text:  'Te acompañamos paso a paso: visado, reconocimiento de títulos, búsqueda de vivienda y adaptación laboral.',
    feat3_back:  'Un proceso claro de principio a fin: inscripción, selección, preparación, llegada e integración. Sin sorpresas, sin letra pequeña. Cada paso explicado y apoyado.',
    feat4_title: 'Red internacional',
    feat4_text:  'Cuando llegues a los Países Bajos, no estarás solo. Hay colombianos que ya pasaron por esto — en salud y en automotriz — y que hoy forman parte de tu red.',
    feat4_back:  'Acceso a una red activa entre Colombia y los Países Bajos construida durante años. Contactos reales que abren puertas reales. Eventos, grupos y apoyo mutuo.',
    feat_img1_back: 'La vida en los Países Bajos: ciclismo, canales y una cultura abierta. Descubre cómo es trabajar y vivir en Holanda.',
    feat_img2_back: 'Acompañamos a enfermeros/as colombianos hacia su primer contrato fijo en los Países Bajos.',

    // WHY LPC GLOBAL TALENT
    why_eyebrow: 'Por qué elegirnos',
    why_h2: '¿Por qué LPC Talent?',
    why1_title: 'Oportunidades Profesionales',
    why1_text: 'Conectamos talento colombiano con empleadores y empresas neerlandesas que ofrecen posiciones reales con responsabilidad y crecimiento.',
    why2_title: 'Acompañamiento Cultural',
    why2_text: 'Preparación completa para el entorno neerlandés — idioma, cultura laboral y vida cotidiana. No llegas solo, llegas preparado.',
    why3_title: 'Proceso Guiado',
    why3_text: 'Un proceso claro de principio a fin: inscripción, selección, preparación, llegada e integración. Sin sorpresas, sin letra pequeña.',
    why4_title: 'Red Internacional',
    why4_text: 'Acceso a una red activa entre Colombia y los Países Bajos construida durante más de 10 años. Contactos reales que abren puertas reales.',

    // HOME PAGE
    home_hero_h1: 'Conectando talento colombiano con oportunidades en los Países Bajos',
    home_card1_title: 'Trabajar en el sector de salud neerlandés',
    home_card1_desc: 'Enfermeros/as profesionales colombianos hacia una plaza fija en residencias, hospitales y más — con apoyo en registro BIG y acompañamiento de principio a fin.',
    home_card2_title: 'Pasantía en una empresa neerlandesa',
    home_card2_desc: 'Pasantías de 3 a 6 meses en empresas neerlandesas — con responsabilidades concretas y un perfil internacional que te diferencia.',
    home_card_cta: 'Más información',

    // INTRO
    intro_eyebrow: 'Quiénes somos',
    intro_h2: 'Dos caminos. Una misión. Talento colombiano hacia los Países Bajos.',
    intro_p: 'LPC Talent no es para todo el mundo — y eso lo decimos con orgullo. Es una <strong>oportunidad real</strong> para quien está dispuesto a invertir en sí mismo, aprender un idioma nuevo y dar un paso que cambia su vida. Somos honestos sobre lo que se necesita. Y acompañamos cada etapa del proceso.',

    // CARE CARD
    care_h3:  'Trabajar en el sector de salud neerlandés',
    care_p:   'Los Países Bajos tienen una enorme escasez de personal de salud. Acompañamos a enfermeros/as profesionales colombianos hacia una plaza fija en residencias de adultos mayores, hospitales y más — incluyendo registro BIG. Nuestro objetivo: ubicarte de forma permanente en una organización que realmente encaje contigo.',
    care_req: 'Disposición para aprender neerlandés B1. Te acompañamos en ese proceso.',
    care_link: 'Más sobre LPC Global Care',
    req_label: 'Requisito:',

    // GLOBAL CARE PAGE
    care_hero_h1: 'Tu carrera como enfermero/a en los Países Bajos comienza aquí.',
    care_hero_sub: 'Los Países Bajos tienen una enorme escasez de personal de salud. Acompañamos a enfermeros/as profesionales colombianos hacia una plaza fija en residencias, hospitales y más — con apoyo en el registro BIG y acompañamiento de principio a fin.',
    care_cta: 'Inscribirme en LPC Global Care',
    care_prog_eyebrow: 'El programa',
    care_what_title: '¿Qué incluye?',
    care_what_lang_not_included_label: 'No incluido',
    care_what_lang_desc: 'LPC ofrece orientación en el proceso de aprendizaje del idioma. La formación es responsabilidad del participante, pero te proporcionamos un directorio de academias recomendadas.',
    care_what_list: [
      'Apoyo en el proceso de registro BIG',
      'Matching con instituciones de salud en los Países Bajos',
      'Asesoría en visado y trámites',
      'Búsqueda de vivienda y adaptación cultural',
      'Acompañamiento completo de principio a fin',
    ],
    care_reqs_eyebrow: 'Requisitos',
    care_reqs_h2: '¿Qué necesitas para aplicar?',
    care_req_dutch_label: 'Idioma',
    care_req_dutch_val: 'No es necesario dominarlo aún — puedes estar en formación o comenzar el proceso con nuestra orientación',
    care_req_profile_label: 'Perfil',
    care_req_profile_val: 'Estudiante de enfermería en etapa final o egresado/a con registro en Rethus',
    care_req_passport_label: 'Documento',
    care_req_passport_val: 'Pasaporte vigente',
    care_req_availability_label: 'Disponibilidad',
    care_req_availability_val: 'Mínimo 1 año de disponibilidad para migrar',
    care_step3_p: 'Te conectamos con una institución de salud que realmente encaje con tu perfil, personalidad y objetivos.',

    // INTERN CARD
    intern_h3:  'Pasantía en una empresa neerlandesa',
    intern_p:   'Estudiantes colombianos de tecnología y automotriz realizan pasantías de 3 a 6 meses en empresas reales de los Países Bajos — con tareas reales, responsabilidad real y un perfil internacional que fortalece tu hoja de vida. Sin café. Solo trabajo, aprendizaje y red de contactos en Europa.',
    intern_req: 'Apoyo de sostenimiento: €1.187/mes (la mitad del salario mínimo en Holanda). Duración: 3–6 meses.',
    intern_link: 'Más sobre LPC Pasantías',

    // PASANTÍAS PAGE
    pasant_hero_h1: 'Tu pasantía en tecnología o automotriz en los Países Bajos comienza aquí.',
    pasant_hero_sub: 'Estudiantes colombianos realizan pasantías de 3 a 6 meses en empresas neerlandesas de tecnología y automotriz — con tareas reales, responsabilidad real y un perfil internacional. Apoyo de sostenimiento: €1.187/mes (la mitad del salario mínimo en Holanda).',
    pasant_cta: 'Inscribirme en LPC Pasantías',
    pasant_prog_eyebrow: 'El programa',
    pasant_what_title: '¿Qué incluye?',
    pasant_what_list: [
      'Matching con empresas neerlandesas de tecnología o automotriz',
      'Apoyo de sostenimiento: €1.187/mes (la mitad del salario mínimo en Holanda)',
      'Asesoría en visado y trámites',
      'Búsqueda de vivienda y adaptación cultural',
      'Acompañamiento completo de principio a fin',
    ],
    pasant_reqs_eyebrow: 'Requisitos',
    pasant_reqs_h2: '¿Qué necesitas para aplicar?',
    pasant_req_student_label: 'Estudiante',
    pasant_req_student_val: 'Matriculado en área automotriz o afín',
    pasant_req_english_label: 'Idioma',
    pasant_req_english_val: 'Inglés conversacional (A2–B1)',
    pasant_req_passport_label: 'Documento',
    pasant_req_passport_val: 'Pasaporte vigente',
    pasant_req_age_label: 'Edad',
    pasant_req_age_val: 'Entre 18 y 30 años',
    pasant_req_license_label: 'Licencia',
    pasant_req_license_val: 'Licencia de conducir categoría B',
    pasant_req_months_label: 'Duración',
    pasant_req_months_val: 'Mínima 6 meses',
    pasant_req_stipend_label: 'Apoyo económico',
    pasant_req_stipend_val: 'Apoyo de sostenimiento: 1.187 euros mensuales',
    pasant_step3_p: 'Te conectamos con una empresa que realmente encaje con tu perfil, personalidad y objetivos.',

    // STATS
    stat1: 'Talentos en proceso',
    stat2: 'Programas',
    stat3: 'Meses de pasantía',
    stat4: 'Acompañamiento completo',

    // PROCESS
    proc_eyebrow: 'Cómo funciona',
    proc_h2: 'De la inscripción a la llegada a los Países Bajos',
    step1_h: 'Inscripción & entrevista',
    step1_p: 'Completas el formulario. Evaluamos si hay compatibilidad entre tú, el programa y la organización en los Países Bajos.',
    step2_h: 'Preparación',
    step2_p: 'Formación en idiomas, orientación cultural y acompañamiento administrativo. Lo organizamos juntos.',
    step3_h: 'Selección & ubicación',
    step3_p: 'Te conectamos con una institución de salud o empresa que realmente encaje con tu perfil, personalidad y objetivos.',
    step4_h: 'Acompañamiento en NL',
    step4_p: 'Desde la llegada hasta la integración — también en los Países Bajos estamos a tu lado. Hasta que estés completamente establecido.',

    // COMPARISON TABLE
    cmp_eyebrow: 'Comparación',
    cmp_h2: '¿Qué programa es para ti?',
    cmp_who: 'Perfil',
    cmp_who_care: 'Enfermeros/as profesionales',
    cmp_who_intern: 'Estudiantes automotrices (IT, ingeniería, etc.)',
    cmp_lang: 'Requisito de idioma',
    cmp_lang_care: 'Neerlandés B1 (te acompañamos)',
    cmp_lang_intern: 'Inglés A2/B1',
    cmp_dur: 'Duración',
    cmp_dur_care: 'Permanente / largo plazo',
    cmp_dur_intern: '3–6 meses',
    cmp_pay: 'Remuneración',
    cmp_pay_care: 'Escala salarial NL de salud',
    cmp_pay_intern: 'aprox. €1.250/mes',
    cmp_lang_train: 'Formación en idiomas',
    cmp_lang_orient: 'Orientación (no incluida)',
    cmp_big: 'Registro BIG (NL)',
    cmp_support: 'Acompañamiento',
    cmp_yes_incl: 'Incluido',
    cmp_yes_full: 'Acompañamiento completo',
    cmp_na: 'No aplica',
    cmp_az: 'De principio a fin',

    // TESTIMONIALS
    test_eyebrow: 'Testimonios',
    test_h2: 'Lo que dicen sobre LPC Talent',
    test1_quote: 'La colaboración con los pasantes colombianos fue un éxito desde el primer día. Su actitud positiva, motivada y profesional aportó una perspectiva internacional renovadora.',
    test1_name: 'Pleun', test1_role: 'Socia, institución de salud neerlandesa',
    test2_quote: 'Una experiencia increíble. El acompañamiento de LPC fue completo, desde la preparación hasta la llegada. Me sentí apoyado en cada paso del proceso.',
    test2_name: 'Carlos M.', test2_role: 'Pasante IT — Medellín → Rotterdam',
    test3_quote: 'Gracias a LPC Talent pude cumplir mi sueño de trabajar en Europa. La formación en neerlandés fue clave y el equipo nunca me dejó solo.',
    test3_name: 'Valentina R.', test3_role: 'Enfermera — Bogotá → Ámsterdam',
    test4_quote: 'El proceso fue transparente y profesional. Me dijeron exactamente qué esperar y cumplieron cada promesa que me hicieron.',
    test4_name: 'Andrés P.', test4_role: 'Pasante Ingeniería — Cali → Eindhoven',
    test5_quote: 'LPC no es solo una agencia, son compañeros de viaje. Estuvieron conmigo desde la primera llamada hasta que me acomodé completamente en Holanda.',
    test5_name: 'María F.', test5_role: 'Pasante UX Design — Medellín → Utrecht',
    test6_quote: 'El nivel de honestidad y apoyo que da LPC no lo encontré en ningún otro programa. Una experiencia que me cambió la vida profesional y personal.',
    test6_name: 'Sebastián O.', test6_role: 'Pasante Data — Barranquilla → Ámsterdam',
    test7_quote: 'Trabajar en una clínica neerlandesa ha sido el mayor reto y la mayor satisfacción de mi vida profesional. LPC hizo posible lo que parecía imposible.',
    test7_name: 'Luisa C.', test7_role: 'Enfermera — Cartagena → Groningen',
    test8_quote: 'En seis meses aprendí más que en años de universidad. La experiencia internacional transformó completamente mi perfil profesional.',
    test8_name: 'Felipe B.', test8_role: 'Pasante Software — Medellín → Delft',
    test9_quote: 'Me prepararon para lo cultural, lo laboral y lo personal. No llegué como turista, llegué como profesional lista para trabajar.',
    test9_name: 'Camila V.', test9_role: 'Pasante Tecnología — Bogotá → Haarlem',
    test10_quote: 'El mejor paso que pude dar en mi carrera. LPC Talent me abrió una puerta que nunca hubiera podido abrir solo.',
    test10_name: 'Diego A.', test10_role: 'Pasante IT — Medellín → La Haya',

    // FAQ
    faq_eyebrow: 'Preguntas frecuentes',
    faq_h2: 'Todo lo que necesitas saber',
    faq_q1: '¿Necesito hablar neerlandés para hacer una pasantía?',
    faq_a1: 'No. Para el programa LPC Pasantías, el inglés a nivel A2/B1 es suficiente. La mayoría de las empresas neerlandesas trabajan en inglés internamente. Para LPC Global Care sí se requiere neerlandés B1 — pero te acompañamos en el proceso de aprendizaje.',
    faq_q2: '¿Cuánto cuesta participar en el programa?',
    faq_a2: 'Los costos varían según el programa y el perfil del candidato. Contáctanos directamente para recibir información personalizada y transparente sobre todos los costos involucrados.',
    faq_q3: '¿Qué incluye el acompañamiento de LPC Talent?',
    faq_a3: 'El acompañamiento incluye: selección y matching, preparación cultural e idiomática, apoyo en trámites de visa, asesoría en búsqueda de vivienda, y acompañamiento continuo durante toda la estadía en los Países Bajos.',
    faq_q4: '¿Puedo quedarme a trabajar en los Países Bajos después de la pasantía?',
    faq_a4: 'Depende del programa. LPC Global Care está diseñado para ubicación permanente desde el inicio. LPC Pasantías es de 3–6 meses. Nuestro objetivo es que cada participante encuentre estabilidad profesional real.',
    faq_q5: '¿Cómo funciona el registro BIG para enfermeras colombianas?',
    faq_a5: 'El registro BIG es el reconocimiento oficial del título profesional en el sector salud de los Países Bajos. LPC Talent te acompaña en todo el proceso: desde la recopilación de documentos hasta la aprobación oficial. Este proceso puede tomar varios meses, por eso empezamos desde el principio.',
    faq_q6: '¿Dónde vivo durante la pasantía o el trabajo?',
    faq_a6: 'LPC Talent te asesora en la búsqueda de vivienda cerca de tu empresa o institución de salud. Te orientamos sobre las opciones disponibles en los Países Bajos, precios aproximados y cómo buscar habitación de forma segura desde Colombia.',
    faq_q7: '¿Qué perfiles de tecnología buscan las empresas neerlandesas?',
    faq_a7: 'Las empresas neerlandesas buscan principalmente: desarrollo de software (Java, Python, .NET), ciencia de datos e IA, diseño UX/UI, ingeniería de sistemas, ciberseguridad y telecomunicaciones. Si tienes un perfil diferente, cuéntanos — siempre evaluamos caso por caso.',
    faq_q8: '¿Puedo aplicar si aún estoy estudiando?',
    faq_a8: 'Sí. LPC Pasantías está diseñado para estudiantes universitarios de últimos semestres y recién graduados de carreras tecnológicas. Para LPC Global Care, necesitas tener tu título de enfermería o salud ya obtenido. Contáctanos para evaluar tu perfil.',
    faq_wa_cta: '¿Tienes otra pregunta?',
    faq_wa_link: 'Escríbenos por WhatsApp',

    // CONTACT FORM
    form_eyebrow:          'Contacto',
    form_h2:               '¿Listo para dar el paso?',
    form_sub:              'Cuéntanos sobre ti y te responderemos en menos de 24 horas.',
    form_name:             'Nombre completo',
    form_name_ph:          'Tu nombre completo',
    form_email:            'Correo electrónico',
    form_email_ph:         'tu@correo.com',
    form_phone:            'Teléfono / WhatsApp',
    form_phone_ph:         '+57 300 000 0000',
    form_program:          'Programa de interés',
    form_program_opt:      '— Selecciona un programa —',
    form_program_care:     'LPC Global Care — Trabajar en salud',
    form_program_pasantias:'LPC Pasantías — Pasantía tecnología',
    form_program_info:     'Quiero más información general',
    form_message:          'Mensaje (opcional)',
    form_message_ph:       'Cuéntanos sobre tu perfil, experiencia e intereses...',
    form_submit:           'Enviar solicitud',
    form_sending:          'Enviando...',
    form_success:          '¡Solicitud enviada con éxito! Te responderemos en menos de 24 horas.',
    form_error:            'Algo salió mal. Por favor escríbenos directamente por WhatsApp.',
    privacy_checkbox:      'He leído y acepto la Política de Tratamiento de Datos Personales',

    // FOOTER
    footer_about:    'LPC Talent hace parte de La Puerta Colombia — más de 10 años siendo el puente entre Colombia y los Países Bajos. Conectamos personas, culturas y oportunidades.',
    footer_programs: 'Programas',
    footer_contact:  'Contacto',
    footer_copy:     '© 2026 La Puerta Colombia SAS · Medellín, Colombia',
    footer_privacy:  'Política de privacidad',
    footer_tagline:  'We care, we connect, we deliver',
  },

  // ── DUTCH ─────────────────────────────────────────────────────────────────
  nl: {
    topbar_wa: 'Voor meer informatie: WhatsApp',

    nav_care:    'Global Care',
    nav_intern:  'Stages',
    nav_about:   'Over LPC Talent',
    nav_how:     'Hoe werkt het',
    nav_faq:     'Veelgestelde vragen',
    nav_contact: 'Contact',
    nav_cta:     'Aanmelden →',

    hero_badge:      'Colombia → Nederland · LPC Talent',
    hero_h1a:        'Jouw weg naar Nederland begint hier:',
    hero_h1b:        'bruggen bouwen van talent over continenten.',
    hero_sub:        'LPC Talent begeleidt Colombiaanse verpleegkundigen naar een vaste baan in de Nederlandse zorg — en biedt automotive studenten een waardevolle stage bij toonaangevende bedrijven. Eerlijk, persoonlijk en van begin tot eind.',
    hero_btn_care:   'Werken in de zorg',
    hero_btn_intern: 'Stage in de techniek',
    trust1: 'Colombiaans talent in Nederland',  trust1_sub: 'Actief in plaatsingsproces',
    trust2: 'Volledige begeleiding',          trust2_sub: 'Wij begeleiden je bij iedere stap van het proces',
    trust3: 'Eerlijk over de vereisten',      trust3_sub: 'Geen valse beloftes, alleen duidelijke informatie',

    req1_label: 'Global Care vereiste',  req1_val: 'Nederlands B1',
    req2_label: 'Pasantías vereiste',    req2_val: 'Engels A2/B1',
    req3_label: 'Levensonderhoud',       req3_val: 'ca. €1.250/maand',
    req4_label: 'Begeleiding',           req4_val: 'Van A tot Z',

    feat1_title: 'Professionele kansen',
    feat1_text:  'Wij verbinden je met echte functies bij Nederlandse bedrijven — legaal contract, eerlijke vergoeding en een proces dat echt werkt.',
    feat1_back:  'Wij verbinden Colombiaans talent met Nederlandse werkgevers die echte functies bieden met verantwoordelijkheid en groei. Inclusief ondersteuning bij CV, sollicitatiegesprekken en onderhandelingen.',
    feat2_title: 'Culturele begeleiding',
    feat2_text:  'Wij begeleiden je bij integratie in de Nederlandse cultuur: taal, gewoontes en dagelijks leven, zodat je met vertrouwen aankomt.',
    feat2_back:  'Volledige voorbereiding op de Nederlandse omgeving: taal, werkcultuur en dagelijks leven. Je bent er niet alleen, je bent er voorbereid. Inclusief workshops en mentorschap voor je aankomst.',
    feat3_title: 'Begeleiding op maat',
    feat3_text:  'Wij begeleiden je bij elke stap: visum, erkenning van diploma\'s, woonruimte zoeken en aanpassing op het werk.',
    feat3_back:  'Een helder proces van begin tot eind: aanmelding, selectie, voorbereiding, aankomst en integratie. Geen verrassingen, geen kleine lettertjes. Elke stap uitgelegd en ondersteund.',
    feat4_title: 'Internationaal netwerk',
    feat4_text:  'Wanneer je in Nederland aankomt, sta je er niet alleen voor. Er zijn Colombianen die dit al hebben meegemaakt — in zorg en automotive — en die nu deel uitmaken van jouw netwerk.',
    feat4_back:  'Toegang tot een actief netwerk tussen Colombia en Nederland, opgebouwd over jaren. Echte contacten die echte deuren openen. Evenementen, groepen en onderlinge steun.',
    feat_img1_back: 'Het leven in Nederland: fietsen, grachten en een open cultuur. Ontdek hoe het is om in Holland te werken en te leven.',
    feat_img2_back: 'Wij begeleiden Colombiaanse verpleegkundigen naar hun eerste vaste contract in Nederland.',

    why_eyebrow: 'Waarom ons kiezen',
    why_h2: 'Waarom LPC Talent?',
    why1_title: 'Professionele Kansen',
    why1_text: 'Wij verbinden Colombiaans talent met Nederlandse werkgevers en bedrijven die echte functies bieden met verantwoordelijkheid en groeiperspectief.',
    why2_title: 'Culturele Begeleiding',
    why2_text: 'Volledige voorbereiding op de Nederlandse omgeving — taal, werkcultuur en dagelijks leven. Je bent er niet alleen, je bent er voorbereid.',
    why3_title: 'Begeleide Aanpak',
    why3_text: 'Een helder proces van begin tot eind: aanmelding, selectie, voorbereiding, aankomst en integratie. Geen verrassingen, geen kleine lettertjes.',
    why4_title: 'Internationaal Netwerk',
    why4_text: 'Toegang tot een actief netwerk tussen Colombia en Nederland, opgebouwd over meer dan 10 jaar. Echte contacten die echte deuren openen.',

    home_hero_h1: 'Colombiaans talent verbinden met kansen in Nederland',
    home_card1_title: 'Werken in de Nederlandse zorg',
    home_card1_desc: 'Colombiaanse verpleegkundigen naar een vaste plek in ouderenzorg, ziekenhuizen en meer — met BIG-registratie en begeleiding van A tot Z.',
    home_card2_title: 'Stage bij een Nederlands bedrijf',
    home_card2_desc: 'Stages van 3 tot 6 maanden bij Nederlandse bedrijven — met echte verantwoordelijkheden en een internationaal profiel dat je onderscheidt.',
    home_card_cta: 'Meer informatie',

    intro_eyebrow: 'Over LPC Talent',
    intro_h2: 'Twee paden. Één missie. Colombiaans talent naar Nederland.',
    intro_p: 'LPC Talent is niet voor iedereen — en dat zeggen we met trots. Dit is een <strong>echte kans</strong> voor wie klaar is om te investeren in zichzelf, bereid is een nieuwe omgeving te omarmen, en een stap wil zetten die zijn leven verandert. We zijn eerlijk over wat er nodig is. En we begeleiden je volledig.',

    care_h3:  'Werken in de Nederlandse zorg',
    care_p:   'Nederland heeft een enorm tekort aan zorgpersoneel. Wij begeleiden Colombiaanse verpleegkundigen naar een vaste plek in ouderenzorg, ziekenhuizen en meer — inclusief BIG-registratie. Ons doel: jou voor het leven plaatsen bij een organisatie die écht bij je past.',
    care_req: 'Bereidheid om Nederlands B1 te leren. Wij begeleiden je daarbij.',
    care_link: 'Meer over LPC Global Care',
    req_label: 'Vereiste:',

    // GLOBAL CARE PAGE
    care_hero_h1: 'Jouw carrière als verpleegkundige in Nederland begint hier.',
    care_hero_sub: 'Nederland heeft een enorm tekort aan zorgpersoneel. Wij begeleiden Colombiaanse verpleegkundigen naar een vaste plek in ouderenzorg, ziekenhuizen en meer — met ondersteuning bij BIG-registratie en begeleiding van A tot Z.',
    care_cta: 'Aanmelden voor LPC Global Care',
    care_prog_eyebrow: 'Het programma',
    care_what_title: 'Wat is inbegrepen?',
    care_what_lang_not_included_label: 'Niet inbegrepen',
    care_what_lang_desc: 'LPC biedt begeleiding bij het taalleerproces. De opleiding zelf is de verantwoordelijkheid van de deelnemer, maar wij bieden een lijst van aanbevolen talenacademies.',
    care_what_list: [
      'Ondersteuning bij het BIG-registratieproces',
      'Matching met zorginstellingen in Nederland',
      'Advies bij visum en aanvragen',
      'Huisvesting en culturele aanpassing',
      'Volledige begeleiding van A tot Z',
    ],
    care_reqs_eyebrow: 'Vereisten',
    care_reqs_h2: 'Wat heb je nodig om te solliciteren?',
    care_req_dutch_label: 'Taal',
    care_req_dutch_val: 'Je hoeft het nog niet te beheersen — je kunt in opleiding zijn of het proces starten met onze begeleiding',
    care_req_profile_label: 'Profiel',
    care_req_profile_val: 'Verpleegkundestudent in eindfase of afgestudeerd met Rethus-registratie',
    care_req_passport_label: 'Document',
    care_req_passport_val: 'Geldig paspoort',
    care_req_availability_label: 'Beschikbaarheid',
    care_req_availability_val: 'Minimaal 1 jaar beschikbaar om te migreren',
    care_step3_p: 'Koppeling aan een zorginstelling die écht bij jouw profiel, persoonlijkheid en ambities past.',

    intern_h3:  'Stage lopen bij een Nederlands bedrijf',
    intern_p:   'Colombiaanse technologie- en automotive studenten lopen 3 tot 6 maanden stage bij echte Nederlandse bedrijven — met echte opdrachten, echte verantwoordelijkheid en een sterk internationaal profiel op hun CV. Geen koffie halen. Gewoon werken, groeien en een netwerk opbouwen in Europa.',
    intern_req: 'Levensonderhoud: €1.187/maand (de helft van het minimumloon in Nederland). Duur: 3–6 maanden.',
    intern_link: 'Meer over LPC Pasantías',

    // PASANTÍAS PAGE
    pasant_hero_h1: 'Jouw stage in technologie of automotive in Nederland begint hier.',
    pasant_hero_sub: 'Colombiaanse studenten lopen 3 tot 6 maanden stage bij Nederlandse bedrijven in technologie en automotive — met echte opdrachten, echte verantwoordelijkheid en een internationaal profiel. Levensonderhoud: €1.187/maand (de helft van het minimumloon in Nederland).',
    pasant_cta: 'Aanmelden voor LPC Pasantías',
    pasant_prog_eyebrow: 'Het programma',
    pasant_what_title: 'Wat is inbegrepen?',
    pasant_what_list: [
      'Matching met Nederlandse bedrijven in technologie of automotive',
      'Levensonderhoud: €1.187/maand (de helft van het minimumloon in Nederland)',
      'Advies bij visum en aanvragen',
      'Huisvesting en culturele aanpassing',
      'Volledige begeleiding van A tot Z',
    ],
    pasant_reqs_eyebrow: 'Vereisten',
    pasant_reqs_h2: 'Wat heb je nodig om te solliciteren?',
    pasant_req_student_label: 'Student',
    pasant_req_student_val: 'Ingeschreven in automotive of aanverwante richting',
    pasant_req_english_label: 'Taal',
    pasant_req_english_val: 'Conversationeel Engels (A2–B1)',
    pasant_req_passport_label: 'Document',
    pasant_req_passport_val: 'Geldig paspoort',
    pasant_req_age_label: 'Leeftijd',
    pasant_req_age_val: 'Tussen 18 en 30 jaar',
    pasant_req_license_label: 'Rijbewijs',
    pasant_req_license_val: 'Rijbewijs categorie B',
    pasant_req_months_label: 'Duur',
    pasant_req_months_val: 'Minimaal 6 maanden',
    pasant_req_stipend_label: 'Vergoeding',
    pasant_req_stipend_val: 'Ondersteuningsvergoeding: € 1.187 per maand',
    pasant_step3_p: 'Koppeling aan een bedrijf dat écht bij jouw profiel, persoonlijkheid en ambities past.',

    stat1: 'Talenten in proces',
    stat2: "Programma's",
    stat3: 'Maanden stage',
    stat4: 'Begeleiding van A tot Z',

    proc_eyebrow: 'Hoe werkt het',
    proc_h2: 'Van aanmelding tot aankomst in Nederland',
    step1_h: 'Aanmelding & intake',
    step1_p: 'Je vult een formulier in. Wij beoordelen of er een match is — met jou, het programma en de organisatie in Nederland.',
    step2_h: 'Voorbereiding',
    step2_p: 'Taaltraining, culturele oriëntatie en praktische begeleiding. Wij regelen het samen — zodat jij gefocust kunt blijven op jouw groei.',
    step3_h: 'Matching & plaatsing',
    step3_p: 'Koppeling aan een zorginstelling of bedrijf dat écht bij jouw profiel, persoonlijkheid en ambities past.',
    step4_h: 'Begeleiding in NL',
    step4_p: 'Van aankomst tot integratie — ook in Nederland staan wij naast je. Totdat je volledig gesetteld bent.',

    cmp_eyebrow: 'Vergelijking',
    cmp_h2: 'Welk programma past bij jou?',
    cmp_who: 'Doelgroep',
    cmp_who_care: 'Verpleegkundigen',
    cmp_who_intern: 'Automotive studenten (IT, engineering, etc.)',
    cmp_lang: 'Taalvereiste',
    cmp_lang_care: 'Nederlands B1 (wij begeleiden)',
    cmp_lang_intern: 'Engels A2/B1',
    cmp_dur: 'Duur',
    cmp_dur_care: 'Permanent / langdurig',
    cmp_dur_intern: '3–6 maanden',
    cmp_pay: 'Vergoeding',
    cmp_pay_care: 'NL zorgverloonschaal',
    cmp_pay_intern: 'ca. €1.250/maand',
    cmp_lang_train: 'Taaltraining',
    cmp_lang_orient: 'Begeleiding (niet inbegrepen)',
    cmp_big: 'BIG-registratie NL',
    cmp_support: 'Begeleiding',
    cmp_yes_incl: 'Inbegrepen',
    cmp_yes_full: 'Volledig begeleid',
    cmp_na: 'Niet van toepassing',
    cmp_az: 'Van A tot Z',

    test_eyebrow: 'Ervaringen',
    test_h2: 'Wat zij zeggen over LPC Talent',
    test1_quote: 'De samenwerking met de Colombiaanse stagiairs was van dag één een groot succes. Hun positieve en professionele houding bracht een verfrissend internationaal perspectief.',
    test1_name: 'Pleun', test1_role: 'Partner bij Nederlandse zorginstelling',
    test2_quote: 'Een ongelooflijke ervaring. De begeleiding van LPC was compleet, van de voorbereiding tot de aankomst. Ik voelde me bij elke stap ondersteund.',
    test2_name: 'Carlos M.', test2_role: 'Stagiair IT — Medellín → Rotterdam',
    test3_quote: 'Dankzij LPC Talent kon ik mijn droom verwezenlijken om in Europa te werken. De Nederlandse taaltraining was essentieel.',
    test3_name: 'Valentina R.', test3_role: 'Verpleegkundige — Bogotá → Amsterdam',
    test4_quote: 'Het proces was transparant en professioneel. Ze vertelden me precies wat ik kon verwachten en kwamen elke belofte na.',
    test4_name: 'Andrés P.', test4_role: 'Stagiair Engineering — Cali → Eindhoven',
    test5_quote: 'LPC is niet zomaar een bureau, het zijn reisgenoten. Ze waren er van het eerste gesprek tot ik volledig gewend was in Nederland.',
    test5_name: 'María F.', test5_role: 'Stagiair UX Design — Medellín → Utrecht',
    test6_quote: 'Het niveau van eerlijkheid en ondersteuning dat LPC biedt vond ik nergens anders. Een ervaring die mijn leven heeft veranderd.',
    test6_name: 'Sebastián O.', test6_role: 'Stagiair Data — Barranquilla → Amsterdam',
    test7_quote: 'Werken in een Nederlandse kliniek was de grootste uitdaging én voldoening van mijn professionele leven. LPC maakte mogelijk wat onmogelijk leek.',
    test7_name: 'Luisa C.', test7_role: 'Verpleegkundige — Cartagena → Groningen',
    test8_quote: 'In zes maanden leerde ik meer dan in jarenlange studie. De internationale ervaring heeft mijn professionele profiel volledig getransformeerd.',
    test8_name: 'Felipe B.', test8_role: 'Stagiair Software — Medellín → Delft',
    test9_quote: 'Ze bereidden me voor op cultureel, professioneel en persoonlijk vlak. Ik arriveerde als een professional klaar om te werken.',
    test9_name: 'Camila V.', test9_role: 'Stagiair Technologie — Bogotá → Haarlem',
    test10_quote: 'De beste stap die ik in mijn carrière heb gezet. LPC Talent opende een deur die ik nooit alleen had kunnen openen.',
    test10_name: 'Diego A.', test10_role: 'Stagiair IT — Medellín → Den Haag',

    faq_eyebrow: 'Veelgestelde vragen',
    faq_h2: 'Alles wat je wilt weten',
    faq_q1: 'Moet ik Nederlands spreken voor een stage?',
    faq_a1: 'Nee. Voor het LPC Pasantías-programma is Engels op A2/B1-niveau voldoende. De meeste Nederlandse bedrijven werken intern in het Engels. Voor LPC Global Care is wel Nederlands B1 vereist — maar wij begeleiden je bij het leerproces.',
    faq_q2: 'Hoeveel kost deelname aan het programma?',
    faq_a2: 'De kosten variëren per programma en kandidaatprofiel. Neem direct contact met ons op voor persoonlijke en transparante informatie over alle kosten.',
    faq_q3: 'Wat omvat de begeleiding van LPC Talent?',
    faq_a3: 'De begeleiding omvat: selectie en matching, culturele en taalbegeleiding, ondersteuning bij de visumaanvraag, advies bij het zoeken naar woonruimte, en doorlopende begeleiding tijdens het verblijf in Nederland.',
    faq_q4: 'Kan ik na de stage in Nederland blijven werken?',
    faq_a4: 'Dat hangt af van het programma. LPC Global Care is gericht op vaste plaatsing vanaf het begin. LPC Pasantías duurt 3–6 maanden. Ons doel is dat elke deelnemer echte professionele stabiliteit vindt.',
    faq_q5: 'Hoe werkt de BIG-registratie voor Colombiaanse verpleegkundigen?',
    faq_a5: 'De BIG-registratie is de officiële erkenning van uw beroepstitel in de Nederlandse zorgsector. LPC Talent begeleidt u bij het volledige proces: van het verzamelen van documenten tot de officiële goedkeuring. Dit proces kan enkele maanden duren, daarom beginnen we vroeg.',
    faq_q6: 'Waar woon ik tijdens de stage of het werk?',
    faq_a6: 'LPC Talent adviseert je bij het zoeken naar woonruimte in de buurt van je bedrijf of zorginstelling. We informeren je over beschikbare opties in Nederland, indicatieve prijzen en hoe je veilig een kamer kunt zoeken vanuit Colombia.',
    faq_q7: 'Welke technologieprofielen zoeken Nederlandse bedrijven?',
    faq_a7: 'Nederlandse bedrijven zoeken voornamelijk: softwareontwikkeling (Java, Python, .NET), data science en AI, UX/UI-design, systeemtechniek, cybersecurity en telecommunicatie. Heb je een ander profiel, vertel het ons — we beoordelen altijd geval per geval.',
    faq_q8: 'Kan ik solliciteren als ik nog studeer?',
    faq_a8: 'Ja. LPC Pasantías is ontworpen voor studenten in hun laatste studiejaren en recent afgestudeerden van technische opleidingen. Voor LPC Global Care moet je al een afgeronde opleiding verpleegkunde of zorg hebben.',
    faq_wa_cta:  'Heb je een andere vraag?',
    faq_wa_link: 'Stuur ons een WhatsApp',

    form_eyebrow:          'Contact',
    form_h2:               'Klaar om de stap te zetten?',
    form_sub:              'Vertel ons over jezelf en we reageren binnen 24 uur.',
    form_name:             'Volledige naam',
    form_name_ph:          'Jouw volledige naam',
    form_email:            'E-mailadres',
    form_email_ph:         'jouw@email.nl',
    form_phone:            'Telefoon / WhatsApp',
    form_phone_ph:         '+57 300 000 0000',
    form_program:          'Programma van interesse',
    form_program_opt:      '— Kies een programma —',
    form_program_care:     'LPC Global Care — Werken in de zorg',
    form_program_pasantias:'LPC Pasantías — Stage technologie',
    form_program_info:     'Ik wil meer algemene informatie',
    form_message:          'Bericht (optioneel)',
    form_message_ph:       'Vertel ons over je profiel, ervaring en interesses...',
    form_submit:           'Aanvraag versturen',
    form_sending:          'Versturen...',
    form_success:          'Aanvraag succesvol verstuurd! We reageren binnen 24 uur.',
    form_error:            'Er ging iets mis. Schrijf ons rechtstreeks via WhatsApp.',
    privacy_checkbox:      'Ik heb het Privacybeleid gelezen en ga ermee akkoord',

    footer_about:    'LPC Talent is onderdeel van La Puerta Colombia — al meer dan 10 jaar de brug tussen Colombia en Nederland. Wij verbinden mensen, culturen en kansen.',
    footer_programs: "Programma's",
    footer_contact:  'Contact',
    footer_copy:     '© 2026 La Puerta Colombia SAS · Medellín, Colombia',
    footer_privacy:  'Privacybeleid',
    footer_tagline:  'We care, we connect, we deliver',
  },

  // ── ENGLISH ───────────────────────────────────────────────────────────────
  en: {
    topbar_wa: 'For more information: WhatsApp',

    nav_care:    'Global Care',
    nav_intern:  'Internships',
    nav_about:   'About LPC Talent',
    nav_how:     'How it works',
    nav_faq:     'FAQ',
    nav_contact: 'Contact',
    nav_cta:     'Apply now →',

    hero_badge:      'Colombia → Netherlands · LPC Talent',
    hero_h1a:        'Your path to the Netherlands starts here:',
    hero_h1b:        'building bridges of talent across continents.',
    hero_sub:        'LPC Talent guides Colombian professional nurses into lasting careers in Dutch healthcare — and connects automotive students with meaningful internships at leading Dutch companies. Honest, personal, and supported every step of the way.',
    hero_btn_care:   'Work in healthcare',
    hero_btn_intern: 'Intern in tech',
    trust1: 'Colombian talent in the Netherlands',  trust1_sub: 'Actively in placement process',
    trust2: 'Full end-to-end support',   trust2_sub: 'We guide you through every step of the process',
    trust3: 'Honest about requirements', trust3_sub: 'No false promises — just clear, upfront information',

    req1_label: 'Global Care requirement',  req1_val: 'Dutch B1',
    req2_label: 'Internship requirement',   req2_val: 'English A2/B1',
    req3_label: 'Living allowance',         req3_val: 'approx. €1.250/month',
    req4_label: 'Support',                  req4_val: 'A to Z',

    feat1_title: 'Professional opportunities',
    feat1_text:  'We connect you with real positions at Dutch companies — legal contract, fair compensation and a process built to actually work.',
    feat1_back:  'We connect Colombian talent with Dutch employers offering real positions with responsibility and growth. Includes CV support, interview prep and contract negotiation.',
    feat2_title: 'Cultural support',
    feat2_text:  'We guide you to integrate into Dutch culture: language, customs and daily life so you arrive with confidence.',
    feat2_back:  'Complete preparation for the Dutch environment: language, work culture and everyday life. You do not arrive alone, you arrive prepared. Includes workshops and mentoring before arrival.',
    feat3_title: 'Guided process',
    feat3_text:  'We support you at every step: visa, diploma recognition, housing search and workplace adjustment.',
    feat3_back:  'A clear process from start to finish: registration, selection, preparation, arrival and integration. No surprises, no small print. Every step explained and supported.',
    feat4_title: 'International network',
    feat4_text:  'When you arrive in the Netherlands, you won\'t be starting from zero. There are Colombians who\'ve been through this — in healthcare and automotive — and they\'re now part of your network.',
    feat4_back:  'Access to an active network between Colombia and the Netherlands, built over years. Real contacts that open real doors. Events, groups and mutual support.',
    feat_img1_back: 'Life in the Netherlands: cycling, canals and an open culture. Discover what it\'s like to work and live in Holland.',
    feat_img2_back: 'We guide Colombian nurses toward their first permanent contract in the Netherlands.',

    why_eyebrow: 'Why choose us',
    why_h2: 'Why LPC Talent?',
    why1_title: 'Professional Opportunities',
    why1_text: 'We connect Colombian talent with Dutch employers and companies that offer real positions with responsibility and genuine growth prospects.',
    why2_title: 'Cultural Support',
    why2_text: 'Complete preparation for the Dutch environment — language, work culture and everyday life. You do not arrive alone, you arrive prepared.',
    why3_title: 'Guided Process',
    why3_text: 'A clear process from start to finish: registration, selection, preparation, arrival and integration. No surprises, no small print.',
    why4_title: 'International Network',
    why4_text: 'Access to an active network between Colombia and the Netherlands, built over more than 10 years. Real contacts that open real doors.',

    home_hero_h1: 'Connecting Colombian talent with opportunities in the Netherlands',
    home_card1_title: 'Work in Dutch healthcare',
    home_card1_desc: 'Colombian professional nurses into permanent positions in elderly care, hospitals and more — with BIG registration support and full guidance from start to finish.',
    home_card2_title: 'Internship at a Dutch company',
    home_card2_desc: '3 to 6-month internships at Dutch companies — with real responsibilities and an international profile that sets you apart.',
    home_card_cta: 'Learn more',

    intro_eyebrow: 'About LPC Talent',
    intro_h2: 'Two paths. One mission. Colombian talent to the Netherlands.',
    intro_p: 'LPC Talent is not for everyone — and we say that with pride. This is a <strong>real opportunity</strong> for those ready to invest in themselves, embrace a new culture, and take a step that changes their life. We are honest about what it takes. And we are with you every step of the way.',

    care_h3:  'Work in Dutch healthcare',
    care_p:   'The Netherlands faces a significant shortage of healthcare staff. We guide Colombian professional nurses into permanent positions in elderly care, hospitals and more — including BIG registration. Our goal: find you a lasting match with an organisation that truly fits you.',
    care_req: 'Willingness to learn Dutch B1. We guide you through it.',
    care_link: 'More about LPC Global Care',
    req_label: 'Requirement:',

    // GLOBAL CARE PAGE
    care_hero_h1: 'Your career as a nurse in the Netherlands starts here.',
    care_hero_sub: 'The Netherlands faces a significant shortage of healthcare staff. We guide Colombian professional nurses into permanent positions in elderly care, hospitals and more — with support on BIG registration and full guidance from start to finish.',
    care_cta: 'Apply for LPC Global Care',
    care_prog_eyebrow: 'The programme',
    care_what_title: 'What is included?',
    care_what_lang_not_included_label: 'Not included',
    care_what_lang_desc: "LPC provides guidance on the language learning process. Training is the participant's responsibility, but we provide a directory of recommended language academies.",
    care_what_list: [
      'Support with the BIG registration process',
      'Matching with healthcare institutions in the Netherlands',
      'Visa and application advice',
      'Housing search and cultural adaptation',
      'Full support from start to finish',
    ],
    care_reqs_eyebrow: 'Requirements',
    care_reqs_h2: 'What do you need to apply?',
    care_req_dutch_label: 'Language',
    care_req_dutch_val: 'You don\'t need to master it yet — you can be in training or start the process with our guidance',
    care_req_profile_label: 'Profile',
    care_req_profile_val: 'Final-year nursing student or graduate with Rethus registration',
    care_req_passport_label: 'Document',
    care_req_passport_val: 'Valid passport',
    care_req_availability_label: 'Availability',
    care_req_availability_val: 'Minimum 1 year availability to relocate',
    care_step3_p: 'We connect you with a healthcare institution that truly fits your profile, personality and ambitions.',

    intern_h3:  'Intern at a Dutch company',
    intern_p:   'Colombian technology and automotive students complete 3–6 month internships at real Dutch companies — with real projects, real responsibility and a strong international credential on their CV. No coffee runs. Just work, growth and building a European network.',
    intern_req: 'Living allowance: €1.187/month (half of the minimum wage in the Netherlands). Duration: 3–6 months.',
    intern_link: 'More about LPC Internships',

    // PASANTÍAS PAGE
    pasant_hero_h1: 'Your tech or automotive internship in the Netherlands starts here.',
    pasant_hero_sub: 'Colombian students complete 3–6 month internships at Dutch technology and automotive companies — with real projects, real responsibility and an international profile. Living allowance: €1.187/month (half of the minimum wage in the Netherlands).',
    pasant_cta: 'Apply for LPC Pasantías',
    pasant_prog_eyebrow: 'The programme',
    pasant_what_title: 'What is included?',
    pasant_what_list: [
      'Matching with Dutch technology or automotive companies',
      'Living allowance: €1.187/month (half of the minimum wage in the Netherlands)',
      'Visa and application advice',
      'Housing search and cultural adaptation',
      'Full support from start to finish',
    ],
    pasant_reqs_eyebrow: 'Requirements',
    pasant_reqs_h2: 'What do you need to apply?',
    pasant_req_student_label: 'Student',
    pasant_req_student_val: 'Enrolled in automotive or related field',
    pasant_req_english_label: 'Language',
    pasant_req_english_val: 'Conversational English (A2–B1)',
    pasant_req_passport_label: 'Document',
    pasant_req_passport_val: 'Valid passport',
    pasant_req_age_label: 'Age',
    pasant_req_age_val: 'Between 18 and 30 years',
    pasant_req_license_label: 'Licence',
    pasant_req_license_val: "Driver's licence category B",
    pasant_req_months_label: 'Duration',
    pasant_req_months_val: 'Minimum 6 months',
    pasant_req_stipend_label: 'Allowance',
    pasant_req_stipend_val: 'Living allowance: €1,187 per month',
    pasant_step3_p: 'We connect you with a company that truly fits your profile, personality and ambitions.',

    stat1: 'Talents in process',
    stat2: 'Programmes',
    stat3: 'Months internship',
    stat4: 'Full A–Z support',

    proc_eyebrow: 'How it works',
    proc_h2: 'From application to arrival in the Netherlands',
    step1_h: 'Application & intake',
    step1_p: 'You fill in the form. We assess whether there is a match — between you, the programme and the organisation in the Netherlands.',
    step2_h: 'Preparation',
    step2_p: 'Language training, cultural orientation and practical support. We handle it together so you can focus on your growth.',
    step3_h: 'Matching & placement',
    step3_p: 'We connect you with a healthcare organisation or company that truly fits your profile, personality and ambitions.',
    step4_h: 'Support in the Netherlands',
    step4_p: 'From arrival to integration — we stand beside you in the Netherlands too. Until you are fully settled.',

    cmp_eyebrow: 'Comparison',
    cmp_h2: 'Which programme is right for you?',
    cmp_who: 'Target group',
    cmp_who_care: 'Professional nurses',
    cmp_who_intern: 'Automotive students (IT, engineering, etc.)',
    cmp_lang: 'Language requirement',
    cmp_lang_care: 'Dutch B1 (we coach you)',
    cmp_lang_intern: 'English A2/B1',
    cmp_dur: 'Duration',
    cmp_dur_care: 'Permanent / long-term',
    cmp_dur_intern: '3–6 months',
    cmp_pay: 'Salary',
    cmp_pay_care: 'Dutch healthcare pay scale',
    cmp_pay_intern: 'approx. €1.250/month',
    cmp_lang_train: 'Language training',
    cmp_lang_orient: 'Guidance (not included)',
    cmp_big: 'BIG registration (NL)',
    cmp_support: 'Support',
    cmp_yes_incl: 'Included',
    cmp_yes_full: 'Fully supported',
    cmp_na: 'Not applicable',
    cmp_az: 'A to Z',

    test_eyebrow: 'Testimonials',
    test_h2: 'What they say about LPC Talent',
    test1_quote: 'Working with the Colombian interns was a success from day one. Their positive, motivated and professional attitude brought a refreshing international perspective.',
    test1_name: 'Pleun', test1_role: 'Partner at Dutch healthcare organisation',
    test2_quote: 'An incredible experience. LPC\'s support was complete, from preparation to arrival. I felt supported at every step of the process.',
    test2_name: 'Carlos M.', test2_role: 'IT Intern — Medellín → Rotterdam',
    test3_quote: 'Thanks to LPC Talent I was able to fulfil my dream of working in Europe. The Dutch language training was key.',
    test3_name: 'Valentina R.', test3_role: 'Nurse — Bogotá → Amsterdam',
    test4_quote: 'The process was transparent and professional. They told me exactly what to expect and kept every promise they made.',
    test4_name: 'Andrés P.', test4_role: 'Engineering Intern — Cali → Eindhoven',
    test5_quote: 'LPC is not just an agency, they are travel companions. They were with me from the first call until I was fully settled in the Netherlands.',
    test5_name: 'María F.', test5_role: 'UX Design Intern — Medellín → Utrecht',
    test6_quote: 'The level of honesty and support that LPC provides I did not find anywhere else. An experience that changed my professional and personal life.',
    test6_name: 'Sebastián O.', test6_role: 'Data Intern — Barranquilla → Amsterdam',
    test7_quote: 'Working in a Dutch clinic has been the greatest challenge and satisfaction of my professional life. LPC made possible what seemed impossible.',
    test7_name: 'Luisa C.', test7_role: 'Nurse — Cartagena → Groningen',
    test8_quote: 'In six months I learned more than in years at university. The international experience completely transformed my professional profile.',
    test8_name: 'Felipe B.', test8_role: 'Software Intern — Medellín → Delft',
    test9_quote: 'They prepared me culturally, professionally and personally. I did not arrive as a tourist, I arrived as a professional ready to work.',
    test9_name: 'Camila V.', test9_role: 'Tech Intern — Bogotá → Haarlem',
    test10_quote: 'The best step I could have taken in my career. LPC Talent opened a door I could never have opened on my own.',
    test10_name: 'Diego A.', test10_role: 'IT Intern — Medellín → The Hague',

    faq_eyebrow: 'Frequently asked questions',
    faq_h2: 'Everything you need to know',
    faq_q1: 'Do I need to speak Dutch for an internship?',
    faq_a1: 'No. For the LPC Pasantías programme, English at A2/B1 level is sufficient. Most Dutch companies work in English internally. For LPC Global Care, Dutch B1 is required — but we guide you through the learning process.',
    faq_q2: 'How much does it cost to participate?',
    faq_a2: 'Costs vary depending on the programme and candidate profile. Contact us directly for personalised and transparent information about all costs involved.',
    faq_q3: "What does LPC Talent's support include?",
    faq_a3: 'Support includes: selection and matching, cultural and language preparation, visa application assistance, housing search advice, and continuous support throughout your stay in the Netherlands.',
    faq_q4: 'Can I stay and work in the Netherlands after the internship?',
    faq_a4: 'It depends on the programme. LPC Global Care is designed for permanent placement from the start. LPC Pasantías is 3–6 months. Our goal is that each participant finds real professional stability.',
    faq_q5: 'How does BIG registration work for Colombian nurses?',
    faq_a5: 'BIG registration is the official recognition of your professional qualification in the Dutch healthcare sector. LPC Talent guides you through the entire process: from gathering documents to official approval. This process can take several months, which is why we start early.',
    faq_q6: 'Where do I live during the internship or work?',
    faq_a6: 'LPC Talent advises you on finding housing near your company or healthcare institution. We guide you on available options in the Netherlands, approximate prices and how to safely search for a room from Colombia.',
    faq_q7: 'What tech profiles are Dutch companies looking for?',
    faq_a7: 'Dutch companies are primarily looking for: software development (Java, Python, .NET), data science and AI, UX/UI design, systems engineering, cybersecurity and telecommunications. If you have a different profile, tell us — we always evaluate case by case.',
    faq_q8: 'Can I apply if I am still studying?',
    faq_a8: 'Yes. LPC Pasantías is designed for university students in their final semesters and recent graduates of technology programmes. For LPC Global Care, you need to have your nursing or healthcare qualification already completed.',
    faq_wa_cta:  'Have another question?',
    faq_wa_link: 'Send us a WhatsApp',

    form_eyebrow:          'Contact',
    form_h2:               'Ready to take the step?',
    form_sub:              'Tell us about yourself and we will respond within 24 hours.',
    form_name:             'Full name',
    form_name_ph:          'Your full name',
    form_email:            'Email address',
    form_email_ph:         'your@email.com',
    form_phone:            'Phone / WhatsApp',
    form_phone_ph:         '+57 300 000 0000',
    form_program:          'Programme of interest',
    form_program_opt:      '— Select a programme —',
    form_program_care:     'LPC Global Care — Work in healthcare',
    form_program_pasantias:'LPC Pasantías — Tech internship',
    form_program_info:     'I want more general information',
    form_message:          'Message (optional)',
    form_message_ph:       'Tell us about your profile, experience and interests...',
    form_submit:           'Send application',
    form_sending:          'Sending...',
    form_success:          'Application sent successfully! We will respond within 24 hours.',
    form_error:            'Something went wrong. Please write to us directly via WhatsApp.',
    privacy_checkbox:      'I have read and accept the Personal Data Treatment Policy',

    footer_about:    'LPC Talent is part of La Puerta Colombia — over 10 years bridging Colombia and the Netherlands. We connect people, cultures and opportunities.',
    footer_programs: 'Programmes',
    footer_contact:  'Contact',
    footer_copy:     '© 2026 La Puerta Colombia SAS · Medellín, Colombia',
    footer_privacy:  'Privacy policy',
    footer_tagline:  'We care, we connect, we deliver',
  },
};
